export const DS_ADOPTION_KEY = 'ds-visual-adoption'

export const DS_COMPONENT_PARAMETER = 'data-ds-component'

export const DS_CONTAINER_PARAMETER = 'data-ds-container'

export const DS_NONE_INDICATOR_PARAMETER = 'data-ds-none'

export const DEFAULT_DS_COMPONENT_WEIGHT_MODIFIER = 1
export const DS_COMPONENTS_WEIGHT_MODIFIER: Partial<Record<string, number>> = {}

export const DS_BACKGROUND_COLORS = ['rgba(0, 0, 0, 0)', 'rgb(244, 245, 247)', 'rgb(255, 255, 255)']

export const BORDER_SIDES = ['Top', 'Right', 'Bottom', 'Left']

export const DS_BORDERS: Array<{ width: string; style: string; color: string }> = [
  {
    color: 'rgb(220, 224, 229)',
    style: 'solid',
    width: '1px',
  },
]

export const DS_FONT_STYLES: Array<{ size: string; lineHeight: string; weight: string }> = [
  // Display styles
  { size: '56px', lineHeight: '68px', weight: '900' }, // text-display-lg (--font-size-display-L)
  { size: '44px', lineHeight: '56px', weight: '900' }, // text-display-md (--font-size-display-M)
  { size: '32px', lineHeight: '40px', weight: '900' }, // text-display-sm (--font-size-display-S)

  // Heading styles
  { size: '24px', lineHeight: '32px', weight: '700' }, // h1, text-heading-1 (--font-size-h1)
  { size: '20px', lineHeight: '28px', weight: '700' }, // h2, text-heading-2 (--font-size-h2)
  { size: '16px', lineHeight: '20px', weight: '600' }, // h3, text-subheading (--font-size-base)
  { size: '16px', lineHeight: '20px', weight: '500' }, // form-label, popover-form-label, panel .panel-header (--font-size-base)

  // Body styles
  { size: '15px', lineHeight: '20px', weight: '500' }, // label, text-strong (--font-size)
  { size: '15px', lineHeight: '20px', weight: '400' }, // Default body, p, text-body
  { size: '13px', lineHeight: '16px', weight: '400' }, // small, text-sm (--font-size-sm)

  // Mobile responsive styles
  { size: '24px', lineHeight: '32px', weight: '700' }, // h1 mobile (--font-size-h1)
  { size: '16px', lineHeight: '24px', weight: '700' }, // h2 mobile (--font-size-base)
  { size: '18px', lineHeight: '24px', weight: '600' }, // h3 mobile (hardcoded 18px)
]

export const DS_FONT_FAMILIES = ['InterVariable, Helvetica, Arial, sans-serif']

export const DS_TEXT_COLORS = [
  'rgb(41, 133, 255)',
  'rgb(146, 104, 247)',
  'rgb(7, 164, 85)',
  'rgb(245, 190, 63)',
  'rgb(231, 77, 52)',
  'rgb(35, 43, 57)',
  'rgb(90, 103, 125)',
  'rgb(133, 146, 163)',
  'rgb(220, 224, 229)',
  'rgb(237, 239, 241)',
  'rgb(244, 245, 247)',
  'rgb(255, 255, 255)',
]

export const DS_BORDER_RADIUS = ['0px', '4px', '6px', '10px']

export const DS_SHADOW_STYLES = [
  // No shadow
  'none', // shadow-none

  // Basic shadows (bottom)
  `rgba(132, 146, 166, 0.08) 0px 8px 16px 0px`, // .shadow-xs
  `rgba(132, 146, 166, 0.12) 0px 8px 16px 0px`, // .shadow-sm
  `rgba(132, 146, 166, 0.16) 0px 12px 24px 0px`, // .shadow
  `rgba(132, 146, 166, 0.16) 0px 24px 36px 0px`, // .shadow-md

  // Right shadows
  `rgba(132, 146, 166, 0.08) 8px 0px 16px -5px`, // .shadow-r-xs
  `rgba(132, 146, 166, 0.12) 8px 0px 16px -5px`, // .shadow-r-sm
  `rgba(132, 146, 166, 0.16) 12px 0px 24px -5px`, // .shadow-r
  `rgba(132, 146, 166, 0.16) 24px 0px 36px -5px`, // .shadow-r-md

  // Top shadows
  `rgba(132, 146, 166, 0.08) 0px -8px 16px -5px`, // .shadow-t-xs
  `rgba(132, 146, 166, 0.12) 0px -8px 16px -5px`, // .shadow-t-sm
  `rgba(132, 146, 166, 0.16) 0px -12px 24px -5px`, // .shadow-t
  `rgba(132, 146, 166, 0.16) 0px -24px 36px -5px`, // .shadow-t-md

  // Left shadows
  `rgba(132, 146, 166, 0.08) -8px 0px 16px -5px`, // .shadow-l-xs
  `rgba(132, 146, 166, 0.12) -8px 0px 16px -5px`, // .shadow-l-sm
  `rgba(132, 146, 166, 0.16) -12px 0px 24px -5px`, // .shadow-l
  `rgba(132, 146, 166, 0.16) -24px 0px 36px -5px`, // .shadow-l-md

  // Horizontal (X-axis) shadows
  `rgba(132, 146, 166, 0.08) -8px 0px 16px -5px, rgba(132, 146, 166, 0.08) 8px 0px 16px -5px`, // .shadow-x-xs
  `rgba(132, 146, 166, 0.12) -8px 0px 16px -5px, rgba(132, 146, 166, 0.12) 8px 0px 16px -5px`, // .shadow-x-sm
  `rgba(132, 146, 166, 0.16) -12px 0px 24px -5px, rgba(132, 146, 166, 0.16) 12px 0px 24px -5px`, // .shadow-x
  `rgba(132, 146, 166, 0.16) -24px 0px 36px -5px, rgba(132, 146, 166, 0.16) 24px 0px 36px -5px`, // .shadow-x-md

  // Vertical (Y-axis) shadows
  `rgba(132, 146, 166, 0.08) 0px -8px 16px -5px, rgba(132, 146, 166, 0.08) 0px 8px 16px -5px`, // .shadow-y-xs
  `rgba(132, 146, 166, 0.12) 0px -8px 16px -5px, rgba(132, 146, 166, 0.12) 0px 8px 16px -5px`, // .shadow-y-sm
  `rgba(132, 146, 166, 0.16) 0px -12px 24px -5px`, // .shadow-y
  `rgba(132, 146, 166, 0.16) 0px -24px 36px -5px, rgba(132, 146, 166, 0.16) 0px 24px 36px -5px`, // .shadow-y-md
]
